module.exports = __webpack_public_path__ + "d77b114b953e43d7740ee7a33b15f1aa.svg";